import router from "./router/index";
import { getToken } from "@/utils/auth";
import { applyThemeClass, resolveRouteTheme } from "@/utils/theme";
// import NProgress from "nprogress"; // progress bar
// import "nprogress/nprogress.css"; // progress bar style
// NProgress.configure({showSpinner: false});

router.beforeEach((to, from, next) => {
  const meta = to.meta || {};
  if (getToken()) {
    if (to.path === "/login") {
      //如果登录成功访问登录页跳转到主页
      next({ path: "/" });
    } else {
      // document.getElementsByTagName('html')[0].className = meta?.theme || ''
      applyThemeClass(resolveRouteTheme(to));
      next();
    }
  } else {
    //判断是否需要认证，没有登录访问去登录页
    if (meta.isAuth === false || to.path === "/login" || to.path === "/forget" || to.path === "/in") {
      next();
    } else {
      next("/login");
    }
  }
});

// router.afterEach((to) => {
//   NProgress.done();
// });
